export default __webpack_public_path__ + "static/media/book_magic.d98ba9f2.jpeg";